export default "__VITE_ASSET__DPDiPUh3__"